"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.global_styles = void 0;
exports.global_styles = {
    backgroundCover: (bgImg) => ({
        backgroundImage: bgImg,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
    }),
    example: {
        width: 50,
        height: 30,
        backgroundColor: '#1F4',
    }
};
//# sourceMappingURL=global.js.map